var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45705 2.18213e-05C5.90478 0.00363189 5.46 0.454264 5.46361 1.00654L5.49303 5.50627L0.993464 5.53568C0.441191 5.53929 -0.00358822 5.98992 2.1821e-05 6.5422C0.00363187 7.09447 0.454264 7.53925 1.00654 7.53564L5.5061 7.50623L5.53551 12.0063C5.53912 12.5586 5.98976 13.0034 6.54203 12.9997C7.0943 12.9961 7.53908 12.5455 7.53547 11.9932L7.50606 7.49315L12.0063 7.46374C12.5586 7.46013 13.0034 7.00949 12.9997 6.45722C12.9961 5.90495 12.5455 5.46017 11.9932 5.46378L7.49298 5.4932L7.46357 0.993464C7.45996 0.441191 7.00933 -0.00358825 6.45705 2.18213e-05Z",
    fill: "#FC4C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.f8c037161ead4cb80d077167a240cbd8.svg";
export { ForwardRef as ReactComponent };